import { render } from "./PickUpPackages.vue?vue&type=template&id=654773d9&scoped=true"
import script from "./PickUpPackages.vue?vue&type=script&lang=js"
export * from "./PickUpPackages.vue?vue&type=script&lang=js"

import "./PickUpPackages.vue?vue&type=style&index=0&id=654773d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-654773d9"

export default script